Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.LayoutHelpers = {
        initialize: function() {
            this.displayOptions = App.request('get:display:options');
            if (gon.previewMode) {
                this.listenForMessage();
            }
            if (this.displayOptions.get('emitInteractionEvents')) {
                this.emitInteractionEvents();
            }
        },
        listenForMessage: function() {
            var receiveMessage = _.throttle(function(event) {
                try {
                    var eventData = JSON.parse(event.data);

                    if (eventData.name === 'pixlee:css:generated') {
                        $('#header_banner_image img').attr('src', eventData.data.displayOptions.headerOptions.bannerImage || '');
                    }
                } catch (error) {
                    return;
                }
            }, 1000);

            window.addEventListener('message', receiveMessage, false);
        },
        emitInteractionEvents: function() {
            this.$el.on('click touchstart touchmove touchend wheel mousemove', this.postInteractionEventMessage);
        },
        postInteractionEventMessage: function(event) {
            var message = {
                name: 'pixlee:interaction:event',
                data: {
                    frame: 'widget',
                    type: event.type,
                    nodeName: event.target.nodeName,
                    id: event.target.id,
                    className: event.target.className
                },
                destination: 'all',
                source: 'widget',
                type: 'relay'
            };
            window.parent.postMessage(JSON.stringify(message), '*');
        },
        templateHelpers: function() {
            var displayOpts = this.displayOptions.get('headerOptions');
            var showSkipContentLinks = this.displayOptions.get('showSkipContentLinks');

            return {
                getLayoutClass: function() {
                    return _.isFalsy(displayOpts) ? '' : displayOpts.layout;
                },
                isHeaderV2: function() {
                    return !_.isFalsy(displayOpts) && Object.keys(displayOpts).length > 1;
                },
                isTile: function() {
                    return displayOpts.layout === 'tile';
                },
                checkSkipContentLinks: function() {
                    return showSkipContentLinks;
                }
            };
        }
    };
});
